module.exports = __webpack_public_path__ + "img/easy_wrong_topic.92bc18ad.svg";